import { ClubeAmigoDomains } from "utils/CommonData";

const domain = window.location.hostname
const localClubeAmigo = localStorage.getItem('ClubeAmigoDomain')
export const ISClubeAmigo = Boolean(ClubeAmigoDomains.includes(domain) || localClubeAmigo)

export const maquininhaLabel = 'Maquininha Digital'
export const maquininhaId = '620458ba8770378b46b4f3a7'
